import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { authService } from '../services/authService';
import { getErrorMessage } from '../utils/errors';
import {
  Container,
  Paper,
  TextField,
  Button,
  Box,
  Alert,
  Typography,
} from '@mui/material';

const RedefinirSenha: React.FC = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') || '';
  const [novaSenha, setNovaSenha] = useState('');
  const [confirmarSenha, setConfirmarSenha] = useState('');
  const [erros, setErros] = useState<{ novaSenha?: string; confirmarSenha?: string }>({});
  const [erro, setErro] = useState('');
  const [sucesso, setSucesso] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    const novosErros: typeof erros = {};
    if (!novaSenha) novosErros.novaSenha = 'Nova senha é obrigatória';
    else if (novaSenha.length < 6) novosErros.novaSenha = 'Mínimo 6 caracteres';
    if (!confirmarSenha) novosErros.confirmarSenha = 'Confirme a nova senha';
    else if (novaSenha !== confirmarSenha) novosErros.confirmarSenha = 'Senhas não conferem';

    if (Object.keys(novosErros).length > 0) {
      setErros(novosErros);
      return;
    }

    setErros({});
    setErro('');
    setLoading(true);

    try {
      await authService.resetPassword({ token, novaSenha, confirmarSenha });
      setSucesso(true);
    } catch (err) {
      setErro(getErrorMessage(err));
    } finally {
      setLoading(false);
    }
  };

  if (sucesso) {
    return (
      <Container disableGutters maxWidth="sm">
        <Box sx={{ mt: 10 }}>
          <Paper elevation={3} sx={{ p: 4 }}>
            <Typography variant="h5" align="center" gutterBottom>
              Senha redefinida
            </Typography>
            <Alert severity="success" sx={{ my: 2 }}>
              Sua senha foi alterada com sucesso. Já pode entrar com a nova senha.
            </Alert>
            <Button
              fullWidth
              variant="contained"
              size="large"
              onClick={() => navigate('/login')}
            >
              Ir para o login
            </Button>
          </Paper>
        </Box>
      </Container>
    );
  }

  return (
    <Container disableGutters maxWidth="sm">
      <Box sx={{ mt: 10 }}>
        <Paper elevation={3} sx={{ p: 4 }}>
          <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
            <img src="/images/logomarca.png" alt="GFrotas" style={{ height: 100 }} />
          </Box>

          <Typography variant="h5" align="center" gutterBottom>
            Redefinir senha
          </Typography>
          <Typography variant="body2" align="center" sx={{ mb: 2 }}>
            Escolha uma nova senha para o seu acesso.
          </Typography>

          {erro && <Alert severity="error" sx={{ mb: 2 }}>{erro}</Alert>}

          {!token && (
            <Alert severity="warning" sx={{ mb: 2 }}>
              Link inválido: o token de recuperação não foi informado.
            </Alert>
          )}

          <form onSubmit={handleSubmit}>
            <TextField
              fullWidth
              label="Nova senha"
              type="password"
              value={novaSenha}
              onChange={(e) => setNovaSenha(e.target.value)}
              error={!!erros.novaSenha}
              helperText={erros.novaSenha}
              margin="normal"
              required
              disabled={!token}
              InputLabelProps={{ shrink: true }}
            />
            <TextField
              fullWidth
              label="Confirmar nova senha"
              type="password"
              value={confirmarSenha}
              onChange={(e) => setConfirmarSenha(e.target.value)}
              error={!!erros.confirmarSenha}
              helperText={erros.confirmarSenha}
              margin="normal"
              required
              disabled={!token}
              InputLabelProps={{ shrink: true }}
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              size="large"
              disabled={loading || !token}
              sx={{ mt: 3 }}
            >
              {loading ? 'Salvando...' : 'Redefinir senha'}
            </Button>
          </form>

          <Box sx={{ mt: 2, textAlign: 'center' }}>
            <Button onClick={() => navigate('/login')}>Voltar para o login</Button>
          </Box>
        </Paper>
      </Box>
    </Container>
  );
};

export default RedefinirSenha;
